export default "__VITE_ASSET__CY6SkOqD__"